import Vue from "vue";
import Vuex from "vuex";

import GAPI from "./gapi.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    gapi: GAPI,
  },
});
